import { useCallback, useContext, useEffect, useState } from 'react'
import { LOGIN_TIME, OAUTH_PROVIDER, PROVIDER_TOKEN } from '../../../assets/constants'
import { persistAuthFromLoginResponse, clearAccessToken } from '../../../services/auth/tokenRefresh'
import { buildDeviceInfoSummary, getDeviceId } from '../../../util/deviceIdentity'
import { validateToken } from '../../../services/apis/auth'
import { AuthHandlerContext } from '../../../App'
import { Box, Button, Typography } from '@mui/material'
import { AuthProvider, ValidateThirdPartyTokenRequest } from '../../../proto/generated/identity'
import { fetchLoginUrl } from '../../../util/authProvider'
import { OAuthLoginProviders } from '../../../reducer/user.reducer'
import ROUTES from '../../../assets/routes'

export default function ShoonyaOAuthRedirectHandler() {
    const authHandlerContext = useContext(AuthHandlerContext)
    const [error, setError] =useState<string | null>(null);
    const params = new Map<string, string>(
        Array.from(new URLSearchParams(window.location.search))
    )

    useEffect(() => {
        validateShoonyaLogin()
    }, [])

    async function validateShoonyaLogin() {
        const idToken = params.get('idToken')
        if (!idToken) {
            setError('Incorrect URL. No token found.');
            return;
        } else {
            const response = await validateProviderToken(
                idToken,
                AuthProvider.SHOONYA
            )
            if (response.token && response.providerToken) {
                persistAuthFromLoginResponse({
                    accessToken: response.token,
                    refreshToken: response.refreshToken,
                })
                localStorage.setItem(PROVIDER_TOKEN, response.providerToken)
                localStorage.setItem(OAUTH_PROVIDER, OAuthLoginProviders.SHOONYA)
                localStorage.setItem(LOGIN_TIME, Date.now().toString())
                const utmParams = sessionStorage.getItem('utm_params')
                if (utmParams && sessionStorage.getItem('gtmAdsTagFired') !== 'true') {
                    const params = JSON.parse(utmParams)
                    if (params?.utm_source === 'googleads2') {
                        eval('dataLayer.push({\'event\': \'logged_in_via_google_ads\'})')
                        sessionStorage.setItem('gtmAdsTagFired', 'true')
                    }
                }
                const { preparePostLoginPinGate } = await import('../acess/PinSessionUnlockGate')
                const gate = await preparePostLoginPinGate()
                if (gate === 'ready') {
                    const { setPinUnlockPending } = await import('../../../util/pinBrowserFlags')
                    setPinUnlockPending()
                    window.location.href = ROUTES.login
                    return
                }
                authHandlerContext.onLoggedIn(true)
            } else if (response.error) {
                setError(response.error)
            }
        }
    }

    const validateProviderToken = async (token: string, authProviderCode: AuthProvider, verifier?: string) => {
        try {
            clearAccessToken()
            const response = await validateToken({
                body: ValidateThirdPartyTokenRequest.fromPartial({
                    tokenInfo: [{
                        key: 'token',
                        value: token
                    }, {
                        key: 'verifier',
                        value: verifier as any
                    }],
                    authProvider: authProviderCode,
                    deviceId: getDeviceId(),
                    deviceInfo: await buildDeviceInfoSummary()
                })
            })
            return { token: response.accessToken, providerToken: response.providerToken, refreshToken: response.refreshToken }
        } catch (error) {
            return { error: "Invalid or Expired token" }
        }
    }

    const onRetryClick = useCallback(() => {
        fetchLoginUrl(OAuthLoginProviders.SHOONYA).then((res) => {
            window.location.href = res
        });
    }, [])

    return (
        <Box
            padding={2}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                width: '100%'
            }}
        >
            <Typography
                variant="h5"
                textAlign='center'
                sx={{ color: 'black', fontSize: '24px' }}
            >
                {error ? error : 'Loggin In...'}
            </Typography>
            {error ? <Button variant='text' color='info' onClick={onRetryClick} >RETRY</Button>: ''}
        </Box>
    )
}
